import {
  Box,
  Dialog,
  DialogContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography as MuiTypography,
} from "@mui/material";
import "../../cssfiles/homepage.css";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomLabel from "../CommonComponents/CustomLabel";
import React, { useEffect, useState } from "react";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomTreeSelect from "../CommonComponents/CustomTreeSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  addTemplate,
  editTemplate,
  getDynamicTag,
  getDynamicTagStandard,
  getTagConfiguration,
  getTemplateDetails,
  getTemplateGroupTree,
  getTemplateTree,
} from "../../Restclient/datacollection";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import ReportDesignerApp from "./ReportDesigner";
import { DownOutlined } from "@ant-design/icons";
import { Radio, Tree } from "antd";
import { setSelectedTab, setTemplateState } from "../../store/cofig_data";
import CustomToast from "../CommonComponents/CustomToast";

function convertTagsToList(tags) {
  return tags.flatMap((tag) =>
    tag.aggregate.map((agg) => `${tag.name}.${agg}~${tag.tagID}`),
  );
}

function convertListToStructure(list) {
  const structureMap = {};

  list.forEach((item) => {
    // Split by ~ to separate the path and key
    const [fullPath, tagID] = item.split("~");

    // Split the path to extract aggregation (last part)
    const parts = fullPath.split(".");
    const agg = parts[parts.length - 1]; // Last part is aggregation
    const name = parts.slice(0, -1).join("."); // Everything except last part is the name

    // If this tagID doesn't exist in the map, create it
    if (!structureMap[tagID]) {
      structureMap[tagID] = {
        tagID: tagID,
        aggregate: [],
        name: name,
      };
    }

    // Add the aggregation to the aggregate array if not already present
    if (!structureMap[tagID].aggregate.includes(agg)) {
      structureMap[tagID].aggregate.push(agg);
    }
  });

  // Convert map to array
  return Object.values(structureMap);
}

export default function Template() {
  const dispatch = useDispatch();
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const themeOperate = useSelector((state) => state.themedata.theme);
  const templateState = useSelector((state) => state.configdata.templateState);
  const userdetails = useSelector((state) => state.logindata.userdetails);

  var code = "0";
  if (userdetails?.User_Role_Details?.Name == "EA_ADMIN") {
    code = "1";
  }

  const [selectedDesigner, setSelectedDesigner] = useState("Standard");
  const [selectedGroupVal, setSelectedGroupVal] = useState();
  const [groupTree, setGroupTree] = useState([]);
  const [templatename, setTemplatename] = useState(null);
  const [templateType, setTemplateType] = useState("Archive");
  const [reportTitle, setReportTitle] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [reportType, setReportType] = useState("General");
  const [dynamicTemplate, setDynamicTemplate] = useState(false);
  const [interval, setInterval] = useState("Hourly");
  const [orientation, setOrientation] = useState("Portrait");
  const [decimalPrecision, setDecimalPrecision] = useState("2");
  const [duration, setDuration] = useState("30 seconds");
  const [selectedTemplateVal, setSelectedTemplateVal] = useState("");
  const [templateTree, setTemplateTree] = useState([]);
  const [designer, setDesigner] = useState(false);
  const [openTagDialog, setOpenTagDialog] = useState(false);
  const [tagConfiguration, setTagConfiguration] = useState([]);
  const [tagNameType, setTagNameType] = useState("0");
  const [selectedTag, setSelectedTag] = useState(null);
  const [aggregationOption, setAggregationOption] = useState([]);
  const [rightList, setRightList] = useState([]);
  const [selectedTagList, setSelectedTagList] = useState([]);
  const [selectedTagDetails, setSelectedTagDetails] = useState(null);
  const [selectedRightItems, setSelectedRightItems] = useState([]);
  const [table_rows, setTable_rows] = useState([]);
  const [tab, setTab] = useState(0);
  const [disabledAggOptions, setDisabledAggOptions] = useState([]);
  const [tagStructure, setTagStructure] = useState([]);
  const [update, setUpdate] = useState(-1);
  const [req, setReq] = useState([]);

  useEffect(() => {
    if (code === "1") {
      setDynamicTemplate(true);
    } else {
      setDynamicTemplate(false);
    }
  }, [code]);

  useEffect(() => {
    setTagStructure(convertListToStructure(table_rows));
  }, [table_rows]);

  useEffect(() => {
    if (selectedTag !== null && selectedTagDetails !== null) {
      let tempDuration = "";
      if (duration === "30 seconds") tempDuration = "30SEC";
      else if (duration === "1 minute") tempDuration = "1MIN";
      else if (duration === "5 minutes") tempDuration = "5MIN";
      else if (duration === "15 minutes") tempDuration = "15MIN";
      else if (duration === "1 hour") tempDuration = "1HR";
      else if (duration === "2 hours") tempDuration = "2HR";
      else if (duration === "4 hours") tempDuration = "4HR";
      else if (duration === "8 hours") tempDuration = "8HR";
      else if (duration === "1 day") tempDuration = "1DAY";
      else if (duration === "1 week") tempDuration = "1WEEK";
      else if (duration === "1 month") tempDuration = "1MONTH";
      else if (duration === "1 year") tempDuration = "1YEAR";

      // Check if selectedTagDetails has storage property
      if (
        selectedTagDetails.storage &&
        Array.isArray(selectedTagDetails.storage)
      ) {
        const item = selectedTagDetails.storage.find(
          (obj) => obj[tempDuration] !== undefined,
        );
        const value = item ? item[tempDuration] : null;

        if (value !== null && Array.isArray(value)) {
          // value should contain the available aggregation options
          // Disable all options that are NOT in the value array
          const allOptions = [
            "SUM",
            "DIFF",
            "AVG",
            "MIN",
            "MAX",
            "SVAL",
            "EVAL",
          ];
          const disabledOptions = allOptions.filter(
            (option) => !value.includes(option),
          );
          setDisabledAggOptions(disabledOptions);
        } else {
          // If no storage found, disable all options
          setDisabledAggOptions([
            "SUM",
            "DIFF",
            "AVG",
            "MIN",
            "MAX",
            "SVAL",
            "EVAL",
          ]);
        }
      } else {
        // If no storage property, disable all options
        setDisabledAggOptions([
          "SUM",
          "DIFF",
          "AVG",
          "MIN",
          "MAX",
          "SVAL",
          "EVAL",
        ]);
      }
    } else {
      // Clear disabled options when no tag is selected
      setDisabledAggOptions([]);
    }
  }, [selectedTag, selectedTagDetails, duration]); // Add duration as dependency

  useEffect(() => {
    setSelectedTag(null);
    setAggregationOption([]);
    setRightList([]);
    setSelectedTagList([]);
    setSelectedTagDetails(null);
    setSelectedRightItems([]);
    setTable_rows([]);
    setTagStructure([]); // **ADD THIS**
    setTab(0);
    setDisabledAggOptions([]);
  }, [selectedDesigner]);

  useEffect(() => {
    getTemplateGroupTree(code, restCallbackGroupTree);
    if (userdetails?.User_Role_Details?.Name == "EA_ADMIN") {
      getDynamicTagStandard(getTagCallback);
    } else {
      getTagConfiguration(getTagCallback);

      // if (dynamicTemplate) {
      //   getDynamicTag(getTagCallback);
      // } else {
      //   getTagConfiguration(getTagCallback);
      // }
    }
  }, [projectId, dynamicTemplate]);

  useEffect(() => {
    if (code === "0") getTemplateTree(restCallbackTemplateTree);
  }, [projectId, update]);

  useEffect(() => {
    if (update >= 1) {
      dispatch(setTemplateState({ state: 0, id: "", name: "" }));
      dispatch(setSelectedTab({ tab: "Template", value: 1 }));
      setTemplatename("");
      setReportTitle("");
      setReportDescription("");
      setInterval("Hourly");
      setDuration("30 seconds");
      setReportType("General");
      setDynamicTemplate(false);
      setTagStructure([]);
      setTable_rows([]);
      setSelectedTagList([]);
      setSelectedDesigner("Standard");
    }
    const timer = setTimeout(() => {
      setReq([]);
      setUpdate(-1);
    }, 3000);
    return () => clearTimeout(timer);
  }, [update]);

  const addTemplateCallback = (res) => {
    setUpdate(res.data);
  };

  useEffect(() => {
    if (templateState.state === 2) {
      getTemplateDetails(
        templateState.id,
        templateState.name,
        restcallbacktemp,
      );
    }
  }, [templateState]);

  useEffect(() => {
    if (openTagDialog) {
      // Sync rightList with table_rows when dialog opens
      setRightList([...table_rows]);
    }
  }, [openTagDialog]);

  const handleSaveStandardTemplate = () => {
    if (
      selectedGroupVal === "" ||
      templatename === "" ||
      templateType === "" ||
      reportTitle === "" ||
      (templateType === "Archive" && interval === "") ||
      orientation === "" ||
      (templateType === "Archive" && tagStructure.length === 0) ||
      (templateType === "Archive" && reportType === "") ||
      (templateType === "Audit" && reportType === "") ||
      (templateType === "Archive" && duration === "") ||
      (templateType === "Archive" && decimalPrecision === "")
    ) {
      if (selectedGroupVal === "") req.push("Template Group");
      if (templatename === "") req.push("Template Name");
      if (reportTitle === "") req.push("Report Title");
      if (templateType === "Archive" && interval === "") req.push("Interval");
      if (orientation === "") req.push("Orientation");
      if (templateType === "Archive" && tagStructure.length === 0)
        req.push("Add tags");
      if (templateType === "Archive" && reportType === "")
        req.push("Report Type");
      if (templateType === "Audit" && reportType === "")
        req.push("Report Type");
      if (templateType === "Archive" && duration === "") req.push("Duration");
      if (templateType === "Archive" && decimalPrecision === "")
        req.push("Decimal Precision");

      setUpdate(3);
      return;
    }
    const tempObj = {
      groupID: selectedGroupVal,
      Name: templatename,
      Designer: selectedDesigner,
      TemplateType: templateType,
      ReportType: reportType,
      Dynamic: dynamicTemplate,
      ReportTitle: reportTitle,
      ReportDescription: reportDescription,
      Tags: tagStructure,
      Duration: duration,
      DecimalDigit: decimalPrecision,
      Orientation: orientation,
      Interval: interval,
      TagType: tagNameType,
    };
    if (templateState.state === 0 || templateState.state === 1) {
      addTemplate(tempObj, code, addTemplateCallback);
    } else if (templateState.state === 2) {
      tempObj["TemplateID"] = templateState.id;
      tempObj["GroupID"] = templateState.name;
      tempObj["TagType"] = tagNameType;
      editTemplate(tempObj, code, addTemplateCallback);
    }
  };

  const handleSaveCustomTemplate = () => {
    if (
      selectedGroupVal === "" ||
      templatename === "" ||
      templateType === "" ||
      (templateType === "Archive" && interval === "") ||
      (templateType === "Archive" && tagStructure.length === 0) ||
      (templateType === "Archive" && reportType === "") ||
      (templateType === "Audit" && reportType === "") ||
      (templateType === "Archive" && duration === "")
    ) {
      if (selectedGroupVal === "") req.push("Template Group");
      if (templatename === "") req.push("Template Name");
      if (templateType === "Archive" && interval === "") req.push("Interval");
      if (templateType === "Archive" && tagStructure.length === 0)
        req.push("Add tags");
      if (templateType === "Archive" && reportType === "")
        req.push("Report Type");
      if (templateType === "Audit" && reportType === "")
        req.push("Report Type");
      if (templateType === "Archive" && duration === "") req.push("Duration");
      setUpdate(3);
      return;
    }
    const tempObj = {
      groupID: selectedGroupVal,
      Name: templatename,
      Designer: selectedDesigner,
      TemplateType: templateType,
      ReportType: reportType,
      Dynamic: dynamicTemplate,
      Tags: tagStructure,
      Interval: interval,
      Duration: duration,
    };
    addTemplate(tempObj, code, addTemplateCallback);
  };

  const saveTaglist = () => {
    setTable_rows([...rightList]);

    // Update selectedTagList to match rightList
    const updatedTagList = convertListToStructure(rightList).map((tag) => ({
      tagID: tag.tagID,
      name: tag.name,
      aggregate: tag.aggregate,
    }));
    setSelectedTagList(updatedTagList);

    setOpenTagDialog(false);
  };

  const moveLeft = () => {
    if (selectedRightItems.length > 0) {
      // Remove selected items from rightList
      const updatedRightList = rightList.filter(
        (item) => !selectedRightItems.includes(item),
      );
      setRightList(updatedRightList);

      // Update selectedTagList by removing the corresponding aggregates
      const updatedSelectedTagList = selectedTagList
        .map((tag) => {
          // Check which aggregates need to be removed for this tag
          const aggregatesToRemove = selectedRightItems
            .filter((item) => item.startsWith(tag.TagName + "."))
            .map((item) => item.substring(item.lastIndexOf(".") + 1));

          if (aggregatesToRemove.length > 0) {
            // Remove the aggregates
            const updatedAggregates = tag.Aggregate.filter(
              (agg) => !aggregatesToRemove.includes(agg),
            );

            if (updatedAggregates.length === 0) {
              return null; // Remove entire tag entry
            }

            return {
              ...tag,
              Aggregate: updatedAggregates,
            };
          }
          return tag;
        })
        .filter((tag) => tag !== null);

      setSelectedTagList(updatedSelectedTagList);

      // Clear selected items
      setSelectedRightItems([]);
    } else {
    }
  };

  const moveRight = () => {
    // if (
    //   selectedTag !== null &&
    //   aggregationOption.length > 0 &&
    //   selectedTagDetails
    // ) {
    //   // Create entries - filter out duplicates
    //   const newRightListEntries = aggregationOption
    //     .map(
    //       (agg) =>
    //         `${selectedTagDetails.fullPath}.${agg}~${selectedTagDetails.key}`,
    //     )
    //     .filter((entry) => !rightList.includes(entry));

    //   if (newRightListEntries.length > 0) {
    //     setRightList([...rightList, ...newRightListEntries]);
    //   }

    if (
      selectedTag !== null &&
      aggregationOption.length > 0 &&
      selectedTagDetails
    ) {
      // Create entries - filter out duplicates
      const newRightListEntries = aggregationOption
        .map(
          (agg) =>
            `${selectedTagDetails.fullPath}.${agg}~${selectedTagDetails.key}`,
        )
        .filter((entry) => {
          const exists = rightList.includes(entry);
          return !exists;
        });

      if (newRightListEntries.length > 0) {
        setRightList([...rightList, ...newRightListEntries]);
      } else {
      }

      // Update selectedTagList (existing logic is fine)
      const existingIndex = selectedTagList.findIndex(
        (item) => item.TagID === selectedTagDetails.key,
      );

      if (existingIndex >= 0) {
        const updatedList = [...selectedTagList];
        const newAggregates = aggregationOption.filter(
          (agg) => !updatedList[existingIndex].Aggregate.includes(agg),
        );

        if (newAggregates.length > 0) {
          updatedList[existingIndex] = {
            ...updatedList[existingIndex],
            Aggregate: [
              ...updatedList[existingIndex].Aggregate,
              ...newAggregates,
            ],
          };
          setSelectedTagList(updatedList);
        }
      } else {
        setSelectedTagList([
          ...selectedTagList,
          {
            Aggregate: [...aggregationOption],
            TagID: selectedTagDetails.key,
            TagName: selectedTagDetails.fullPath,
          },
        ]);
      }

      // Clear selections
      setSelectedTag(null);
      setSelectedTagDetails(null);
      setAggregationOption([]);
      setDisabledAggOptions([]);
    } else if (
      selectedTag !== null &&
      tagNameType === "0" &&
      selectedTagDetails
    ) {
      // Add tag without aggregation (Live mode) - just tag path and ID, no .AGG suffix
      const newEntry = `${selectedTagDetails.fullPath}~${selectedTagDetails.key}`;

      if (!rightList.includes(newEntry)) {
        setRightList([...rightList, newEntry]);
      }

      // Update selectedTagList without aggregation
      const existingIndex = selectedTagList.findIndex(
        (item) => item.TagID === selectedTagDetails.key,
      );

      if (existingIndex < 0) {
        setSelectedTagList([
          ...selectedTagList,
          {
            Aggregate: [],
            TagID: selectedTagDetails.key,
            TagName: selectedTagDetails.fullPath,
          },
        ]);
      }

      // Clear selections
      setSelectedTag(null);
      setSelectedTagDetails(null);
      setAggregationOption([]);
      setDisabledAggOptions([]);
    }
  };

  function handleAggregationOption(selectedValue, isChecked) {
    if (isChecked) {
      // Add the value if checked (isChecked = true means checkbox is now checked)
      setAggregationOption([...aggregationOption, selectedValue]);
    } else {
      // Remove the value if unchecked (isChecked = false means checkbox is now unchecked)
      setAggregationOption(
        aggregationOption.filter((item) => item !== selectedValue),
      );
    }
  }

  const onChange = (e) => {
    setTagNameType(e.target.value);
  };

  const handleClose = (event, reason) => {
    if (reason === "closeButton") {
      setOpenTagDialog(false);
    }
  };

  const getTagCallback = (res) => {
    setTagConfiguration(res);
  };

  const restCallbackTemplateTree = (res) => {
    setTemplateTree(res.data);
    setSelectedTemplateVal(res.data.length > 0 ? res.data[0].value : "");
  };

  const restCallbackGroupTree = (res) => {
    setGroupTree(res.data);
    // For state 2 (edit mode), use templateState.name
    // For state 1 (add to group), use templateState.id
    // For state 0 (new), use first group
    setSelectedGroupVal(
      templateState.state === 0
        ? res.data.length > 0
          ? res.data[0].value
          : ""
        : templateState.state === 1
          ? templateState.id
          : templateState.state === 2
            ? templateState.name
            : "",
    );
  };

  const restcallbacktemp = (res) => {
    setSelectedDesigner(res.data.designer);
    setGroupTree([
      {
        title: res.data.groupname,
        type: "group",
        value: templateState.id,
      },
    ]);
    setSelectedGroupVal(templateState.id);
    setTemplatename(res.data.name);
    setTemplateType(res.data.templateType);
    setReportTitle(res.data.report_title);
    setReportDescription(res.data.report_description);
    setInterval(res.data.interval);
    setDuration(res.data.duration);
    setReportType(res.data.reportType);
    setDynamicTemplate(res.data.dynamic);
    setTagStructure(res.data.tags);
    setTable_rows(convertTagsToList(res.data.tags));
    setDecimalPrecision(res.data.decimal_digit);
    setOrientation(res.data.orientation);

    const reconstructedTagList = res.data.tags.map((tag) => ({
      tagID: tag.tagID,
      name: tag.name,
      aggregate: tag.aggregate,
    }));
    setSelectedTagList(reconstructedTagList);
  };

  // Helper to create node titles with right-aligned icons
  const renderTitle = (title, type, key, node) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
        }}
      >
        {/* Left side: title with icon */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {type === "tag" ? (
            <CustomCheckbox
              checked={selectedTag === key}
              onChange={(checked) => {
                if (checked) {
                  setSelectedTag(key);
                  // Store the full tag details including path
                  setSelectedTagDetails({
                    key: key,
                    title: title,
                    fullPath: node.fullPath || title,
                    parentPath: node.parentPath || "",
                    storage: node.storage,
                  });
                } else {
                  // Clear everything when unchecked
                  setSelectedTag(null);
                  setSelectedTagDetails(null);
                }
              }}
            />
          ) : (
            <></>
          )}
          <span
            style={{ color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B" }}
          >
            {title}
          </span>
        </div>
      </div>
    );
  };

  // Helper to process tree data and add fullPath to each node
  const processTreeData = (nodes, parentPath = "") => {
    if (!nodes || !Array.isArray(nodes)) {
      return [];
    }
    return nodes.map((node) => {
      const currentPath = parentPath
        ? `${parentPath}.${node.title || node.key}`
        : node.title || node.key;
      const processedNode = {
        ...node,
        fullPath: currentPath,
        parentPath: parentPath,
        title: renderTitle(node.title || node.key, node.type, node.key, {
          ...node,
          fullPath: currentPath,
          parentPath: parentPath,
        }),
        children: node.children
          ? processTreeData(node.children, currentPath)
          : undefined,
      };
      return processedNode;
    });
  };

  if (designer) {
    return (
      <div
        style={{ height: "100%", boxSizing: "border-box" }}
        className="compliance-config"
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "right",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <CustomCancelButton
                buttonText={"Close"}
                onClick={() => setDesigner(false)}
              />
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
              gap: "8px",
              padding: "8px",
              backgroundColor: "var(--PrimaryBackground)",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <ReportDesignerApp url={selectedTemplateVal} />
          </Box>
        </Box>
      </div>
    );
  }

  return (
    <div
      style={{ height: "100%", boxSizing: "border-box" }}
      className="compliance-config"
    >
      {update === 15 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Template Edited Successfully!"}
          onClose={() => setUpdate(-1)}
        />
      )}
      {update === -15 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Editing Template!"}
          onClose={() => setUpdate(-1)}
        />
      )}
      {update === 1 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"New Template Created!"}
          onClose={() => setUpdate(-1)}
        />
      )}
      {update === 0 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Creating Template!"}
          onClose={() => setUpdate(-1)}
        />
      )}
      {update === 2 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Template Name Already Exists!"}
          onClose={() => setUpdate(-1)}
        />
      )}
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "right",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <CustomButton
              buttonText={"Save"}
              onClick={
                selectedDesigner === "Standard"
                  ? handleSaveStandardTemplate
                  : handleSaveCustomTemplate
              }
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <CustomCancelButton
              buttonText={"Cancel"}
              onClick={() => {
                dispatch(setTemplateState({ state: 0, id: "", name: "" }));
                dispatch(setSelectedTab({ tab: "Template", value: 1 }));
                setTemplatename("");
                setReportTitle("");
                setReportDescription("");
                setInterval("Hourly");
                setDuration("30 seconds");
                setReportType("General");
                setDynamicTemplate(false);
                setTagStructure([]);
                setTable_rows([]);
                setSelectedTagList([]);
                setSelectedDesigner("Standard");
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            {update === 3 ? (
              <CustomLabel
                labelText={"Required values must be filled: " + req.join(", ")}
                color={"red"}
              />
            ) : (
              <></>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "left",
            gap: "8px",
            padding: "8px",
            backgroundColor: "var(--PrimaryBackground)",
            boxSizing: "border-box",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              gap: "32px",
              padding: "8px",
              backgroundColor: "var(--SecondaryBackground)",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <table
              width="100%"
              style={{
                textAlign: "left",
                padding: "0px",
                margin: "0px",
                boxSizing: "border-box",
              }}
            >
              <tr>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Designer*"}
                    htmlFor={"designer-type"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomDropDown
                    options={
                      code === "1" ? ["Standard"] : ["Standard"] //code === "1" ? ["Standard"] : ["Standard", "Custom"]
                    }
                    onChange={(val) => {
                      setSelectedDesigner(val);
                      setTemplateType("Archive");
                    }}
                    width={227}
                    name={"designer-type"}
                    defaultValue={selectedDesigner}
                    disabled={templateState.state === 2 ? true : false}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Template Group*"}
                    htmlFor={"template-group"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} style={{ paddingBottom: "36px" }}>
                  <CustomTreeSelect
                    options={groupTree}
                    value={selectedGroupVal}
                    defaultValue={selectedGroupVal}
                    onChange={(val) => setSelectedGroupVal(val)}
                    placeholder=""
                    width="227px"
                    fontSize="16px"
                    disabled={templateState.state === 2 ? true : false}
                    disabledItemValues={(item) =>
                      item.title?.startsWith("sg-") ||
                      item.value?.startsWith("sg-")
                    }
                  />
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Template Name*"}
                    htmlFor={"template-name"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomTextField
                    id={"template-name"}
                    width={227}
                    onChange={(val) => setTemplatename(val)}
                    defaultValue={templatename}
                    permittedCharacters={"^[a-zA-Z0-9_]*$"}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Template Type*"}
                    htmlFor={"template-type"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} style={{ paddingBottom: "36px" }}>
                  <CustomDropDown
                    options={
                      selectedDesigner === "Standard"
                        ? ["Archive", "Alerts", "Audit"]
                        : ["Archive"]
                    }
                    onChange={(val) => {
                      setTemplateType(val);
                      if (val === "Audit") {
                        setReportType("Login Activity");
                      } else if (val === "Archive") {
                        setReportType("General");
                      }
                    }}
                    width={227}
                    name={"template-type"}
                    defaultValue={templateType}
                    disabledOptions={
                      projectId === "All" ? ["Alerts", "Audit"] : []
                    }
                    disabled={templateState.state === 2 ? true : false}
                  />
                </td>
              </tr>
              {selectedDesigner === "Standard" && (
                <tr>
                  <td style={{ paddingBottom: "36px" }}>
                    <CustomLabel
                      labelText={"Report Title*"}
                      htmlFor={"report-title"}
                      color={"var(--SecondaryText)"}
                      paddingTop={6}
                    />
                  </td>
                  <td style={{ paddingBottom: "36px" }}>
                    <CustomTextField
                      id={"report-title"}
                      width={227}
                      onChange={(val) => setReportTitle(val)}
                      defaultValue={reportTitle}
                      permittedCharacters={"^[a-zA-Z0-9_\\s]*$"}
                    />
                  </td>
                  <td style={{ paddingBottom: "36px" }}>
                    <CustomLabel
                      labelText={"Report Description"}
                      htmlFor={"report-description"}
                      color={"var(--SecondaryText)"}
                      paddingTop={6}
                    />
                  </td>
                  <td colSpan={2} style={{ paddingBottom: "36px" }}>
                    <CustomTextField
                      id={"report-description"}
                      width={227}
                      onChange={(val) => setReportDescription(val)}
                      defaultValue={reportDescription}
                      permittedCharacters={"^[a-zA-Z0-9_\\s]*$"}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={
                      templateType === "Archive" ? "Interval*" : "Interval"
                    }
                    htmlFor={"interval"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomDropDown
                    options={["Hourly", "Daily", "Weekly", "Monthly", "Yearly"]}
                    onChange={(val) => {
                      setInterval(val);
                    }}
                    width={227}
                    name={"report-type"}
                    defaultValue={templateType === "Archive" ? interval : null}
                    disabled={templateType === "Archive" ? false : true}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={
                      templateType === "Archive" ? "Duration*" : "Duration"
                    }
                    htmlFor={"duration"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} style={{ paddingBottom: "36px" }}>
                  <CustomDropDown
                    options={
                      interval === "Hourly"
                        ? [
                            "30 seconds",
                            "1 minute",
                            "5 minutes",
                            "15 minutes",
                            "1 hour",
                          ]
                        : interval === "Daily"
                          ? [
                              "30 seconds",
                              "1 minute",
                              "5 minutes",
                              "15 minutes",
                              "1 hour",
                              "1 day",
                            ]
                          : interval === "Weekly"
                            ? [
                                "30 seconds",
                                "1 minute",
                                "5 minutes",
                                "15 minutes",
                                "1 hour",
                                "1 day",
                                "1 week",
                              ]
                            : interval === "Monthly"
                              ? [
                                  "30 seconds",
                                  "1 minute",
                                  "5 minutes",
                                  "15 minutes",
                                  "1 hour",
                                  "1 day",
                                  "1 week",
                                  "1 month",
                                ]
                              : interval === "Yearly"
                                ? [
                                    "30 seconds",
                                    "1 minute",
                                    "5 minutes",
                                    "15 minutes",
                                    "1 hour",
                                    "1 day",
                                    "1 week",
                                    "1 month",
                                    "1 year",
                                  ]
                                : []
                    }
                    onChange={(val) => {
                      setDuration(val);
                    }}
                    width={227}
                    name={"report-type"}
                    defaultValue={templateType === "Archive" ? duration : null}
                    disabled={templateType === "Archive" ? false : true}
                  />
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={
                      templateType === "Archive" || templateType === "Audit"
                        ? "Report Type*"
                        : "Report Type"
                    }
                    htmlFor={"report-type"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomDropDown
                    options={
                      templateType === "Archive"
                        ? ["General"]
                        : ["Login Activity", "User Logs"]
                    }
                    onChange={(val) => {
                      setReportType(val);
                    }}
                    width={227}
                    name={"report-type"}
                    defaultValue={
                      templateType === "Archive" || templateType === "Audit"
                        ? reportType
                        : null
                    }
                    disabled={
                      templateType === "Audit"
                        ? false
                        : templateType !== "Archive" ||
                            templateState.state === 2
                          ? true
                          : false
                    }
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Dynamic Template"}
                    htmlFor={"dynamic-template"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomCheckbox
                    defaultChecked={dynamicTemplate}
                    checked={dynamicTemplate}
                    disabled={
                      code === "1" || templateType !== "Archive" ? true : false
                    }
                    onChange={(val) => setDynamicTemplate(val)}
                  />
                </td>
                <td
                  style={{
                    paddingBottom: "36px",
                    textAlign: "right",
                    paddingRight: "20px",
                  }}
                >
                  {templateType === "Archive" ? (
                    <CustomActionButton
                      buttonText={"Add Tags"}
                      onClick={() => setOpenTagDialog(true)}
                    />
                  ) : (
                    <CustomActionButton
                      disabled={true}
                      buttonText={"Add Tags"}
                    />
                  )}
                </td>
              </tr>
              {selectedDesigner === "Standard" && (
                <tr>
                  <td style={{ paddingBottom: "36px" }}>
                    <CustomLabel
                      labelText={
                        templateType === "Archive"
                          ? "Decimal Precision*"
                          : "Decimal Precision"
                      }
                      htmlFor={"decimal-precision"}
                      color={"var(--SecondaryText)"}
                      paddingTop={6}
                    />
                  </td>
                  <td style={{ paddingBottom: "36px" }}>
                    <CustomTextField
                      id={"decimal-precision"}
                      width={227}
                      disabled={templateType === "Archive" ? false : true}
                      onChange={(val) => {
                        setDecimalPrecision(val);
                      }}
                      type={"number"}
                      defaultValue={
                        templateType === "Archive" ? decimalPrecision : ""
                      }
                      permittedCharacters={"^[0-9]*$"}
                    />
                  </td>
                  <td style={{ paddingBottom: "36px" }}>
                    <CustomLabel
                      labelText={"Orientation"}
                      htmlFor={"orientation"}
                      color={"var(--SecondaryText)"}
                      paddingTop={6}
                    />
                  </td>
                  <td colSpan={2} style={{ paddingBottom: "36px" }}>
                    <CustomDropDown
                      options={["Portrait", "Landscape"]}
                      onChange={(val) => {
                        setOrientation(val);
                      }}
                      width={227}
                      name={"report-type"}
                      defaultValue={orientation}
                    />
                  </td>
                </tr>
              )}
            </table>
          </Box>
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              gap: "32px",
              padding: "8px",
              backgroundColor: "var(--SecondaryBackground)",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  // gap: "27px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    borderBottom: "1px solid var(--table-boarder-line)",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  }}
                >
                  <MuiTypography
                    onClick={() => {
                      setTab(0);
                    }}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 700,
                      color:
                        tab === 0
                          ? "var(--HighlightedText_Stroke)"
                          : "var(--grey-variation-tableLK)",
                      cursor: "pointer",
                    }}
                  >
                    Taglist
                  </MuiTypography>
                  <MuiTypography
                    onClick={() => {
                      setTab(1);
                    }}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 700,
                      color:
                        tab === 1
                          ? "var(--HighlightedText_Stroke)"
                          : "var(--grey-variation-tableLK)",
                      cursor: "pointer",
                    }}
                  >
                    {selectedDesigner === "Custom" ? "Designer" : ""}
                  </MuiTypography>
                </Box>
                {tab === 0 && (
                  <TableContainer
                    component={Paper}
                    sx={{
                      width: "780px",
                      height: "600px",
                      paddingLeft: "0px",
                      backgroundColor: "var(--secondary-backgroundLK)",
                      paddingRight: "0px",
                    }}
                    elevation={0}
                  >
                    <Table stickyHeader sx={{ width: "100%" }} size="small">
                      <TableBody>
                        {table_rows.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                              height: "9px",
                              "& > *": {
                                borderBottom:
                                  "1px solid var(--table-boarder-line)",
                              },
                            }}
                          >
                            <TableCell
                              colSpan={2}
                              key={index}
                              component="th"
                              scope="row"
                              sx={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tablerowsLK)",
                              }}
                            >
                              {row.split("~")[0]}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                {selectedDesigner === "Custom" && tab === 1 && (
                  <table
                    width="100%"
                    style={{
                      textAlign: "left",
                      padding: "0px",
                      margin: "0px",
                      boxSizing: "border-box",
                    }}
                  >
                    <tr>
                      <td
                        style={{ paddingBottom: "36px", paddingRight: "32px" }}
                      >
                        <CustomLabel
                          labelText={"Template*"}
                          htmlFor={"select-template"}
                          color={"var(--SecondaryText)"}
                          paddingTop={6}
                        />
                      </td>
                      <td style={{ paddingBottom: "36px" }}>
                        <CustomTreeSelect
                          options={templateTree}
                          value={selectedTemplateVal}
                          defaultValue={selectedTemplateVal}
                          onChange={(val) => setSelectedTemplateVal(val)}
                          disabledItemValues={(item) => item.type === "group"}
                          placeholder=""
                          width="670px"
                          fontSize="16px"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan={2}
                        style={{ paddingBottom: "36px", textAlign: "right" }}
                      >
                        <CustomButton
                          buttonText={"Launch Designer"}
                          onClick={() => setDesigner(true)}
                        />
                      </td>
                    </tr>
                  </table>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {
        <Dialog
          maxWidth={"xl"}
          open={openTagDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              event.preventDefault();
            } else {
              handleClose(event, reason);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            style: {
              backgroundColor: themeOperate === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
            },
          }}
          BackdropProps={{
            style: {
              backgroundColor:
                themeOperate === "dark"
                  ? "rgba(255,255,255,0.7)"
                  : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                }}
              >
                <MuiTypography
                  sx={{
                    color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  Add Tags
                </MuiTypography>
                <div style={{ flexGrow: 1 }}> </div>

                <CustomCancelButton
                  buttonText={"Cancel"}
                  onClick={(event) => {
                    // Restore to saved state
                    setRightList([...table_rows]);
                    setSelectedTag(null);
                    setSelectedTagDetails(null);
                    setAggregationOption([]);
                    setSelectedRightItems([]);
                    setDisabledAggOptions([]);
                    handleClose(event, "closeButton");
                  }}
                />
                <div style={{ width: "8px" }}></div>
                <CustomButton
                  buttonText={"Save"}
                  onClick={() => {
                    saveTaglist();
                    setOpenTagDialog(false);
                  }}
                />
              </div>
              <div
                style={{
                  width: "900px",
                  height: "600px",
                  backgroundColor:
                    themeOperate === "dark" ? "#1e1e1e" : "#FFFFFF",
                  padding: "16px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    width: "40%",
                    height: "calc(100% - 16px)",
                    backgroundColor:
                      themeOperate === "dark" ? "#000000" : "#EFEFEF",
                    padding: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: "10px",
                      borderBottom:
                        themeOperate === "dark"
                          ? "1px solid #3c3c3c"
                          : "1px solid #c1c1c1",
                    }}
                  >
                    <MuiTypography
                      sx={{
                        color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                        fontSize: "16px",
                        fontWeight: 700,
                      }}
                    >
                      Tags
                    </MuiTypography>
                    <div style={{ flexGrow: 1 }}> </div>
                  </div>
                  <div
                    style={{
                      backgroundColor:
                        themeOperate === "dark" ? "#000000" : "#EFEFEF",
                      color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                      height: "calc(100% - 48px)",
                      width: "100%",
                      overflow: "auto",
                    }}
                  >
                    <Tree
                      style={{
                        backgroundColor:
                          themeOperate === "dark" ? "#000000" : "#EFEFEF",
                        color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                      }}
                      switcherIcon={<DownOutlined />}
                      selectable={false}
                      // onSelect={onSelect}
                      treeData={processTreeData(tagConfiguration)}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "20%",
                    height: "calc(100% - 32px)",
                    padding: "16px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <Radio.Group
                    onChange={onChange}
                    defaultValue={tagNameType}
                    buttonStyle="solid"
                  >
                    <Radio.Button value="0">Live</Radio.Button>
                    <Radio.Button value="1">Historical</Radio.Button>
                  </Radio.Group>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <CustomButton
                      onClick={moveRight}
                      buttonText={">"}
                      disabled={
                        selectedTag === null ||
                        (tagNameType === "1" && aggregationOption.length === 0)
                      }
                    />
                    <CustomButton
                      onClick={moveLeft}
                      buttonText={"<"}
                      disabled={selectedRightItems.length === 0}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor:
                        themeOperate === "dark" ? "#000000" : "#EFEFEF",
                      padding: "16px",
                      visibility: tagNameType === "1" ? "visible" : "hidden",
                    }}
                  >
                    <CustomCheckbox
                      disabled={
                        code !== "1" &&
                        dynamicTemplate === false &&
                        (selectedTag === null ||
                          disabledAggOptions.includes("SUM"))
                      }
                      checked={aggregationOption.includes("SUM")}
                      onChange={(val) => handleAggregationOption("SUM", val)}
                    />
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <CustomLabel
                      fontWeight={300}
                      fontSize={14}
                      color={"var(--PrimaryText)"}
                      labelText={"SUMMATION"}
                    />
                    <br />

                    <CustomCheckbox
                      disabled={
                        code !== "1" &&
                        dynamicTemplate === false &&
                        (selectedTag === null ||
                          disabledAggOptions.includes("DIFF"))
                      }
                      checked={aggregationOption.includes("DIFF")}
                      onChange={(val) => handleAggregationOption("DIFF", val)}
                    />
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <CustomLabel
                      fontWeight={300}
                      fontSize={14}
                      color={"var(--PrimaryText)"}
                      labelText={"DIFFERENCE"}
                    />
                    <br />

                    <CustomCheckbox
                      disabled={
                        code !== "1" &&
                        dynamicTemplate === false &&
                        (selectedTag === null ||
                          disabledAggOptions.includes("AVG"))
                      }
                      checked={aggregationOption.includes("AVG")}
                      onChange={(val) => handleAggregationOption("AVG", val)}
                    />
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <CustomLabel
                      fontWeight={300}
                      fontSize={14}
                      color={"var(--PrimaryText)"}
                      labelText={"AVERAGE"}
                    />
                    <br />

                    <CustomCheckbox
                      disabled={
                        code !== "1" &&
                        dynamicTemplate === false &&
                        (selectedTag === null ||
                          disabledAggOptions.includes("MIN"))
                      }
                      checked={aggregationOption.includes("MIN")}
                      onChange={(val) => handleAggregationOption("MIN", val)}
                    />
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <CustomLabel
                      fontWeight={300}
                      fontSize={14}
                      color={"var(--PrimaryText)"}
                      labelText={"MINIMUM"}
                    />
                    <br />

                    <CustomCheckbox
                      disabled={
                        code !== "1" &&
                        dynamicTemplate === false &&
                        (selectedTag === null ||
                          disabledAggOptions.includes("MAX"))
                      }
                      checked={aggregationOption.includes("MAX")}
                      onChange={(val) => handleAggregationOption("MAX", val)}
                    />
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <CustomLabel
                      fontWeight={300}
                      fontSize={14}
                      color={"var(--PrimaryText)"}
                      labelText={"MAXIMUM"}
                    />
                    <br />

                    <CustomCheckbox
                      disabled={
                        code !== "1" &&
                        dynamicTemplate === false &&
                        (selectedTag === null ||
                          disabledAggOptions.includes("SVAL"))
                      }
                      checked={aggregationOption.includes("SVAL")}
                      onChange={(val) => handleAggregationOption("SVAL", val)}
                    />
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <CustomLabel
                      fontWeight={300}
                      fontSize={14}
                      color={"var(--PrimaryText)"}
                      labelText={"START VALUE"}
                    />
                    <br />

                    <CustomCheckbox
                      disabled={
                        code !== "1" &&
                        dynamicTemplate === false &&
                        (selectedTag === null ||
                          disabledAggOptions.includes("EVAL"))
                      }
                      checked={aggregationOption.includes("EVAL")}
                      onChange={(val) => handleAggregationOption("EVAL", val)}
                    />
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <CustomLabel
                      fontWeight={300}
                      fontSize={14}
                      color={"var(--PrimaryText)"}
                      labelText={"END VALUE"}
                    />
                    <br />
                  </div>
                </div>
                <div
                  style={{
                    width: "40%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      height: "calc(100% - 16px)",
                      width: "calc(100% - 16px)",
                      backgroundColor:
                        themeOperate === "dark" ? "#000000" : "#EFEFEF",
                      padding: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "10px",
                        borderBottom:
                          themeOperate === "dark"
                            ? "1px solid #3c3c3c"
                            : "1px solid #c1c1c1",
                      }}
                    >
                      <MuiTypography
                        sx={{
                          color:
                            themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                          fontSize: "16px",
                          fontWeight: 700,
                        }}
                      >
                        Selected {/* ({rightList.length}) */}
                      </MuiTypography>
                      <div style={{ flexGrow: 1 }}> </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        marginTop: "8px",
                        overflow: "auto",
                        height: "calc(100% - 48px)",
                      }}
                    >
                      {rightList.length === 0 ? (
                        <MuiTypography
                          sx={{
                            color:
                              themeOperate === "dark" ? "#888888" : "#999999",
                            fontSize: "14px",
                            fontStyle: "italic",
                          }}
                        >
                          No tags added yet
                        </MuiTypography>
                      ) : (
                        rightList.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              padding: "4px",
                            }}
                          >
                            <CustomCheckbox
                              checked={selectedRightItems.includes(item)}
                              onChange={(checked) => {
                                if (checked) {
                                  // Add to selected items
                                  setSelectedRightItems([
                                    ...selectedRightItems,
                                    item,
                                  ]);
                                } else {
                                  // Remove from selected items
                                  setSelectedRightItems(
                                    selectedRightItems.filter(
                                      (i) => i !== item,
                                    ),
                                  );
                                }
                              }}
                            />
                            <CustomLabel
                              fontWeight={300}
                              fontSize={14}
                              color={"var(--PrimaryText)"}
                              labelText={item.split("~")[0]}
                            />
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          </DialogContent>
        </Dialog>
      }
    </div>
  );
}
